export default {"src":"/_next/static/media/clock.f3bca333.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};